'use client';

import { X, ArrowRight } from 'lucide-react';
import { useState, useEffect } from 'react';
import Link from 'next/link';

const TOP_BANNER_KEY = 'topBannerDismissed_sokoplay';

export default function TopBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if banner was previously dismissed
        const isDismissed = localStorage.getItem(TOP_BANNER_KEY);
        if (!isDismissed) {
            setIsVisible(true);
        }
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem(TOP_BANNER_KEY, 'true');
    };

    if (!isVisible) return null;

    return (
        <div
            className="fixed top-16 left-0 lg:left-[var(--sidebar-rail-w,4rem)] w-full lg:w-[calc(100%-var(--sidebar-rail-w,4rem))] z-30 bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 text-white shadow-lg border-t border-emerald-400/20 transition-[left,width] duration-300 ease-in-out"
        >
            <div className="max-w-8xl mx-auto py-2.5 px-4 sm:px-6 lg:px-8">
                <div className="flex items-start sm:items-center justify-between gap-4">
                    <Link
                        href="/news/sokoplay-is-here"
                        className="group flex items-start sm:items-center gap-2.5 flex-1 min-w-0"
                    >
                        <span className="shrink-0 mt-0.5 sm:mt-0 bg-white/15 text-green-100 text-[10px] font-bold uppercase tracking-wide px-1.5 py-1 rounded-full leading-none">
                            New
                        </span>
                        <p className="text-sm font-medium leading-snug">
                            <span className="font-bold">SokoPlay</span> is live — a new way to play, unlocked for every account linked with Kick.{' '}
                            <span className="inline-flex items-center gap-1 underline decoration-green-200/50 underline-offset-2 group-hover:text-green-200 font-bold whitespace-nowrap">
                                Read more <ArrowRight size={14} />
                            </span>
                        </p>
                    </Link>

                    <div className="flex items-center gap-3 shrink-0">
                        <button
                            onClick={handleDismiss}
                            className="text-white hover:text-green-100 transition-colors p-1 hover:bg-white/10 rounded"
                            aria-label="Close banner"
                        >
                            <X size={18} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}